var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-card',{staticClass:"mt-4"},[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.$i18n.t('$l.app.notAuthorizedAccessToPage'))+" "+_vm._s(_vm.$route.params.from)+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }